// extracted by mini-css-extract-plugin
export var selectedLicense = "SalesInfo-module--selectedLicense--9jyTb";
export var selectLicenseType = "SalesInfo-module--selectLicenseType--wv21-";
export var addCart = "SalesInfo-module--addCart--y4QVG";